module.exports = __webpack_public_path__ + "img/causation-with-a-human-face-cover.cf73a7e6.jpg";